export type PolygonSearchDTO = GeoJSON.Polygon | GeoJSON.MultiPolygon;

export type RadiusSearchDTO = GeoJSON.Point & {
  radius_metres: number;
};

export type GSSSearchDTO = {
  mode: "gss";
  gssCodes: string[];
};

export type SearchLocationDTO = PolygonSearchDTO | RadiusSearchDTO | GSSSearchDTO;

export function isPolygonSearchDTO(location: SearchLocationDTO): location is PolygonSearchDTO {
  return "type" in location && (location.type === "Polygon" || location.type === "MultiPolygon");
}

export function isRadiusSearchDTO(location: SearchLocationDTO): location is RadiusSearchDTO {
  return "type" in location && location.type === "Point" && "radius_metres" in location;
}

export function isGSSSearchDTO(location: SearchLocationDTO): location is GSSSearchDTO {
  return "mode" in location && location.mode === "gss";
}
